export const getBoardExtendedFields = {
  success: true,
  availableFields: [
    {
      title: "Shirt Size",
      icon: "male fas",
      networkFieldID: 1,
      boardColumnType: 8,
      isCurrentlyOnBoard: true,
    },
    {
      title: "Gender",
      icon: "venus-mars fas",
      networkFieldID: 2,
      boardColumnType: 8,
      isCurrentlyOnBoard: true,
    },
    {
      title: "Class Year",
      icon: "graduation-cap fas",
      networkFieldID: 3,
      boardColumnType: 6,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Birthday",
      icon: "birthday-cake far",
      networkFieldID: 4,
      boardColumnType: 5,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Address",
      icon: "map-marker-alt fas",
      networkFieldID: 5,
      boardColumnType: 7,
      isCurrentlyOnBoard: true,
    },
    {
      title: "Anniversary",
      icon: "heart-square fas",
      networkFieldID: 6,
      boardColumnType: 5,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Baptism Date",
      icon: "cross far",
      networkFieldID: 7,
      boardColumnType: 5,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Occupation",
      icon: "briefcase fas",
      networkFieldID: 8,
      boardColumnType: 4,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Interests",
      icon: "stars fas",
      networkFieldID: 9,
      boardColumnType: 4,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Prefix",
      icon: "signature fas",
      networkFieldID: 10,
      boardColumnType: 8,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Address",
      icon: "map-marked fas",
      networkFieldID: 325,
      boardColumnType: 7,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Household Status",
      icon: "id-badge fas",
      networkFieldID: 326,
      boardColumnType: 9,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Test Select List",
      icon: "ballot-check fas",
      networkFieldID: 327,
      boardColumnType: 8,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Shared Text",
      icon: "keyboard fas",
      networkFieldID: 490,
      boardColumnType: 4,
      isCurrentlyOnBoard: false,
    },
    {
      title: "NumberRange",
      icon: "calculator fas",
      networkFieldID: 491,
      boardColumnType: 6,
      isCurrentlyOnBoard: false,
    },
    {
      title: "Multiline Text",
      icon: "keyboard fas",
      networkFieldID: 492,
      boardColumnType: 4,
      isCurrentlyOnBoard: true,
    },
    {
      title: "Sacraments",
      icon: "file-certificate far",
      isCurrentlyOnBoard: false,
      networkFieldID: null,
      fieldTypeInstanceStructureGroupingID: 1, //This is sacraments
    },
  ],
  isApp: false,
  userID: 2,
};
